import { entityConstants } from "../constants";
import { entityApi } from "../helpers";
import { createSelector } from "reselect";
const normalizeText = (text) =>
  (text || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

const matchSearch = (target, query) => {
  const normTarget = normalizeText(target);
  const normQuery = normalizeText(query);
  if (normTarget.indexOf(normQuery) !== -1) return true;

  const words = normQuery.split(/\s+/).filter(w => w.length > 0);
  if (words.length > 1) {
    return words.every(word => normTarget.indexOf(word) !== -1);
  }
  return false;
};


//Filter entities
const entitiesSelector = state => state.entities.entities;
const searchTermSelector = state => state.entities.entityQuery;
export const filteredEntities = createSelector(
  [entitiesSelector, searchTermSelector],
  (entities, entityQuery) => {
    if (!entities || !Array.isArray(entities)) return [];
    if (!entityQuery || entityQuery.length < 2) return [];
    return entities.filter(
      entity =>
        matchSearch(entity.Nombre, entityQuery) ||
        (entity.Tags && matchSearch(entity.Tags, entityQuery))
    );
  }
);

//Filter streets
const streetsSelector = state => state.entities.streets;
const searchStreetSelector = state => state.entities.streetQuery;
export const filteredStreets = createSelector(
  [streetsSelector, searchStreetSelector],
  (streets, streetQuery) => {
    if (!streets) return undefined;
    if (!streetQuery || streetQuery.length < 2) return undefined;
    const filtered = streets.filter(street => {
      const name = street.Nombre || street.nomCalle || "";
      const fullName = `${street.TipoVia || ""} ${name}`.trim();

      return (
        matchSearch(street.TipoVia, streetQuery) ||
        matchSearch(name, streetQuery) ||
        matchSearch(fullName, streetQuery)
      );
    });
    return filtered;
  }
);

//Filter buildings
const buildingsSelector = state => state.entities.buildings;
const searchBuildingSelector = state => state.entities.streetQuery;
export const filteredBuildings = createSelector(
  [buildingsSelector, searchBuildingSelector],
  (buildings, streetQuery) => {
    if (!buildings) return undefined;
    if (!streetQuery || streetQuery.length < 2) return undefined;
    const filtered = buildings.filter(
      building => matchSearch(building.Nombre, streetQuery)
    );
    return filtered;
  }
);

// The initial application state
let initialState = {
  entities: entityApi.loadEntities() || [],
  entity: entityApi.loadEntity(),
  entityInfo: entityApi.loadEntityInfo(),
  entityConfig: entityApi.loadEntityConfig(),
  streets: entityApi.loadEntityStreets() || [],
  externalStreets: [],
  buildings: entityApi.loadEntityBuildings() || []
};

// Takes care of changing the application state
export const entities = (state = initialState, action) => {
  switch (action.type) {
    case entityConstants.ENTITY_SEARCH:
      return { ...state, entityQuery: action.entityQuery };
    case entityConstants.ENTITY_SEARCH_CLEAR:
      return { ...state, entityQuery: "" };
    case entityConstants.STREET_SEARCH:
      return { ...state, streetQuery: action.streetQuery };
    case entityConstants.STREET_SEARCH_SUCCESS:
      return { ...state, externalStreets: action.externalStreets };
    case entityConstants.STREET_SEARCH_FAILURE:
      return { ...state, externalStreets: [] };
    case entityConstants.STREET_SEARCH_CLEAR:
      return { ...state, streetQuery: "", externalStreets: [] };
    case entityConstants.GETALL_REQUEST:
      return { ...state, loading: action.loading };
    case entityConstants.GETALL_SUCCESS:
      return { ...state, entities: action.entities };
    case entityConstants.ENTITY_FAILURE:
    case entityConstants.GETALL_FAILURE:
      return { ...state, error: action.error };
    case entityConstants.ENTITY_SUCCESS:
    case entityConstants.ENTITY_CHANGED:
      return { ...state, entity: action.entity };
    case entityConstants.ENTITY_INFO_SUCCESS:
      return { ...state, entityInfo: action.entityInfo };
    case entityConstants.ENTITY_STREETS:
      return { ...state, streets: action.streets };
    case entityConstants.ENTITY_BUILDINGS:
      return { ...state, buildings: action.buildings };
    case entityConstants.ENTITY_CONFIG:
      return { ...state, entityConfig: action.entityConfig };
    case entityConstants.CLEAR_ERROR:
      return { ...state, error: "" };
    default:
      return state;
  }
};

export default entities;
